import React from 'react';

export default function CardDashboardVazio(props) {
  return (
    <div
      className={props.classe}
      style={{
        maxWidth: props.maxW !== undefined ? props.maxW : 540,
        maxHeight: props.maxH !== undefined ? props.maxH : 505,
        width: props.width !== undefined ? props.width : '28vw',
        backgroundColor: 'white',
        minWidth: props.minW ? props.minW : 0,
        height: props.height !== undefined ? props.height : 540,
        marginRight: props.right !== undefined ? props.right : 0,
        marginTop: props.top !== undefined ? props.top : 0,
        borderRadius: 4,
        boxShadow: '0px 3px 6px #00000029',
      }}
    >
      <div style={{ padding: 8, display: 'flex', flexDirection: 'column', height: '100%' }}>
        {props.children}
      </div>
    </div>
  );
}
